import React from 'react';
import { compose, branch, renderComponent, setDisplayName } from 'react-recompose';
import Loader from '../Loader';

export default compose(
  setDisplayName('GraphQLLoader'),
  branch(
    ({ data }) => data && data.loading,
    renderComponent(({ loader }) => <Loader {...loader} active />),
  ),
);
